<template>
	<div class="rich_text_body">
		<div v-for="(content, index) in contentArr" :key="index">
			<div class="wrapper ql-editor" v-html="content"></div>
			<video v-if="videoArr[index] !== null" :poster="cover" controls :width="width > 500 ? 450 : width-20">
				<source :src="videoArr[index]" />
			</video>
		</div>
	</div>
</template>
<script>

export default {
	name: 'bctos-rich-text',
	props: { 
		nodes: {}, 
		width: { type: Number, default: 450 },
		cover: { type: String, default: '' } 
	},
	data() {
		return {
			contentArr: [],
			videoArr: [],
			posterArr: [],
			curNodes: null,
		};
	},
	created() {
		this.parseVideo();
	},
	methods: {
		parseVideo() {
			if (typeof this.nodes != 'string') {
				//不是HTML字符串格式的暂不处理
				this.contentArr[0] = this.nodes;
				this.videoArr[0] = null;
				return false;
			}
			//同步解决如果图片太大超出手机显示界面的问题
			this.curNodes = this.nodes.replace(/\<img/g, '<img style="max-width:98%!important;height:auto;"');
			this.curNodes = this.curNodes.replace("<iframe", `<video controls="" autoplay=""`).replace("</iframe>", '</video>');
			let arr = this.curNodes.split('</video>');
			let reg = /<video([\s\S]*)/g;
			for (let i in arr) {
				var item = arr[i];
				var urlMatch = item.match(/<video[\s\S]*src=\"(.*?)\"/);
				// var urlMatch2 = item.match(/<video[\s\S]*poster=\"(.*?)\"/);
				if (urlMatch && urlMatch.length > 1) {
					this.videoArr[i] = urlMatch[1];
				} else {
					this.videoArr[i] = null;
				}
				// if (urlMatch2 && urlMatch2.length > 1) {
				// 	this.posterArr[i] = urlMatch2[1];
				// } else {
				// 	this.posterArr[i] = null;
				// }
				this.contentArr[i] = item.replace(reg, '');
			}
			this.$forceUpdate()
		}
	}
};
</script>

<style scoped>
/* .wrapper{
  white-space: pre-wrap;
} */
/* .wrapper >>> .ql-indent-1{
  padding-left: 1em;
}
.wrapper >>> .ql-align-center{
  text-align: center;
} */
.rich_text_body{
	padding: 10px;
}

>>> p {
	/* white-space: pre-wrap; */
	margin-block-start: 0em;
	margin-block-end: 1em;
  /* font-size: 16px;
  line-height: 28px;
  text-align: left;
  color: rgb(238, 238, 238);
  color: #585858;
  text-indent: 2em; */
}

</style>
